"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RatingSelect = RatingSelect;

var React = _interopRequireWildcard(require("react"));

var _index = require("../../index");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var RatingSelectValue;

(function (RatingSelectValue) {
  RatingSelectValue[RatingSelectValue["ONE"] = 1] = "ONE";
  RatingSelectValue[RatingSelectValue["TWO"] = 2] = "TWO";
  RatingSelectValue[RatingSelectValue["THREE"] = 3] = "THREE";
  RatingSelectValue[RatingSelectValue["FOUR"] = 4] = "FOUR";
  RatingSelectValue[RatingSelectValue["FIVE"] = 5] = "FIVE";
})(RatingSelectValue || (RatingSelectValue = {}));

function RatingSelect(_ref) {
  var className = _ref.className,
      defaultValue = _ref.defaultValue,
      onChange = _ref.onChange,
      divProps = _objectWithoutProperties(_ref, ["className", "defaultValue", "onChange"]);

  var _React$useState = React.useState(defaultValue || null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      selectedValue = _React$useState2[0],
      setSelectedValue = _React$useState2[1];

  var _React$useState3 = React.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      hoveredValue = _React$useState4[0],
      setHoveredValue = _React$useState4[1];

  var classes = (0, _classnames.default)([_index.Classes.RATING_SELECT, className]);
  React.useEffect(function () {
    if (defaultValue) setSelectedValue(defaultValue);
  }, [defaultValue]);

  var changeRating = function changeRating(rating) {
    setSelectedValue(rating);
    if (onChange) onChange(rating);
  };

  function handleRatingClick(newSelectedValue) {
    if (newSelectedValue === selectedValue) return changeRating(null);
    changeRating(newSelectedValue);
  }

  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, divProps), [1, 2, 3, 4, 5].map(function (rating) {
    var isSelected = selectedValue ? rating <= selectedValue : undefined;
    var isHovered = hoveredValue ? rating <= hoveredValue : undefined;
    var isHovering = !!hoveredValue;
    return /*#__PURE__*/React.createElement(RatingStar, {
      key: rating,
      handleRatingClick: handleRatingClick,
      isHovered: isHovered,
      isHovering: isHovering,
      isSelected: isSelected,
      rating: rating,
      setHoveredValue: setHoveredValue
    });
  }));
}

function RatingStar(_ref2) {
  var handleRatingClick = _ref2.handleRatingClick,
      isHovered = _ref2.isHovered,
      isHovering = _ref2.isHovering,
      isSelected = _ref2.isSelected,
      rating = _ref2.rating,
      setHoveredValue = _ref2.setHoveredValue;
  var fillColor = isSelected ? _index.Colors.YELLOW_50 : _index.Colors.IVORY_30;

  if (isHovering) {
    fillColor = isHovered ? _index.Colors.YELLOW_30 : _index.Colors.IVORY_30;
  }

  var handleMouseEnter = function handleMouseEnter() {
    return setHoveredValue(rating);
  };

  var handleMouseLeave = function handleMouseLeave() {
    return setHoveredValue(null);
  };

  var handleClick = function handleClick() {
    return handleRatingClick(rating);
  };

  var classes = (0, _classnames.default)([_index.Classes.RATING_SELECT_ITEM, _index.Classes.FOCUS_DISABLED]);
  /**
   * Divs aren't really necessary here but the CSS can be strange with spans and inline / inline blocks
   */

  return /*#__PURE__*/React.createElement(_index.Tooltip, {
    content: "".concat(rating),
    className: classes,
    wrapperTagName: "div",
    targetTagName: "div"
  }, /*#__PURE__*/React.createElement("div", {
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onClick: handleClick
  }, /*#__PURE__*/React.createElement(_index.Icon16, {
    icon: _index.IconNames16.STAR_FILLED,
    fill: fillColor
  })));
}